export default __webpack_public_path__ + "static/media/agent-profile.a680ac03.png";